/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_Revoke_BodyInputs */

const en_us2_body_assessment_consent_revoke_body = /** @type {(inputs: Body_Assessment_Consent_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every body photo is deleted right away. The numbers stay in your history, and you can delete those separately.`)
};

const pt_br2_body_assessment_consent_revoke_body = /** @type {(inputs: Body_Assessment_Consent_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as fotos do corpo são apagadas na hora. Os números continuam no seu histórico, e dá para apagar cada um separadamente.`)
};

const es_419_body_assessment_consent_revoke_body = /** @type {(inputs: Body_Assessment_Consent_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las fotos del cuerpo se borran de inmediato. Los números se quedan en tu historial, y puedes borrarlos por separado.`)
};

const pt_pt2_body_assessment_consent_revoke_body = /** @type {(inputs: Body_Assessment_Consent_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as fotos do corpo são apagadas de imediato. Os números continuam no teu histórico, e podes apagar cada um separadamente.`)
};

const fr_fr2_body_assessment_consent_revoke_body = /** @type {(inputs: Body_Assessment_Consent_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les photos du corps sont supprimées immédiatement. Les chiffres restent dans ton historique, et tu peux les supprimer séparément.`)
};

const de_de2_body_assessment_consent_revoke_body = /** @type {(inputs: Body_Assessment_Consent_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Körperfotos werden sofort gelöscht. Die Zahlen bleiben in deinem Verlauf, und du kannst sie einzeln löschen.`)
};

const it_it2_body_assessment_consent_revoke_body = /** @type {(inputs: Body_Assessment_Consent_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le foto del corpo vengono eliminate subito. I numeri restano nel tuo storico, e puoi eliminarli a parte.`)
};

/**
* | output |
* | --- |
* | "Every body photo is deleted right away. The numbers stay in your history, and you can delete those separately." |
*
* @param {Body_Assessment_Consent_Revoke_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_revoke_body = /** @type {((inputs?: Body_Assessment_Consent_Revoke_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_Revoke_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_revoke_body(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_revoke_body(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_revoke_body(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_revoke_body(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_revoke_body(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_revoke_body(inputs)
	return en_us2_body_assessment_consent_revoke_body(inputs)
});
export { body_assessment_consent_revoke_body as "body-assessment.consent_revoke_body" }